import testingReducer from "./testingReducer";
import { crewEmployeeReducer } from "./crewEmployeeReducer";
import { supervisorReducer } from "./supervisorReducer";
import { ambulanceReducer } from "./ambulances";
import { parkingBayReducer } from "./parkingBay";
import { loginReducer } from "./login";
import { districtsReducer } from "./districts";
import { ambulanceEmployeeMappingReducer } from "./ambulanceEmployeeMapping";
import { shiftReducer } from "./shift";
import notificationReducer from "./notification";
import { attendanceShiftReducer } from "./attendanceShifts";
import { tenantsReducer } from "./tenants";

const rootReducer = {
  testing: testingReducer,
  supervisor: supervisorReducer,
  crewEmployee: crewEmployeeReducer,
  ambulances: ambulanceReducer,
  parkingbay: parkingBayReducer,
  currentUser: loginReducer,
  districts: districtsReducer,
  ambulanceEmployeeMapping: ambulanceEmployeeMappingReducer,
  shift: shiftReducer,
  notification: notificationReducer,
  attendanceShift: attendanceShiftReducer,
  tenants: tenantsReducer,
}

export default rootReducer